(() => {
  "use strict";


  const FOOTER_SELECTOR =
    "[data-barros-footer]";


  const MOBILE_QUERY =
    window.matchMedia(
      "(max-width: 749px)"
    );


  const instances =
    new Map();


  class BarrosFooter {

    constructor(
      footer
    ) {

      this.footer =
        footer;


      this.menus =
        Array.from(
          footer.querySelectorAll(
            ".barros-footer__menu"
          )
        );


      this.localizationSelects =
        Array.from(
          footer.querySelectorAll(
            "[data-barros-footer-localization]"
          )
        );


      this.isMobile =
        null;


      this.handleViewport =
        this.handleViewport.bind(
          this
        );


      this.handleLocalization =
        this.handleLocalization.bind(
          this
        );


      this.initialize();
    }


    initialize() {

      this.syncMenus();


      if (
        typeof MOBILE_QUERY.addEventListener ===
        "function"
      ) {

        MOBILE_QUERY.addEventListener(
          "change",
          this.handleViewport
        );

      } else {

        MOBILE_QUERY.addListener(
          this.handleViewport
        );

      }


      this.localizationSelects.forEach(
        (select) => {

          select.addEventListener(
            "change",
            this.handleLocalization
          );

        }
      );

    }


    handleViewport() {

      this.syncMenus();

    }


    syncMenus() {

      const nextIsMobile =
        MOBILE_QUERY.matches;


      if (
        nextIsMobile ===
        this.isMobile
      ) {

        return;

      }


      this.isMobile =
        nextIsMobile;


      this.menus.forEach(
        (menu) => {

          if (
            nextIsMobile
          ) {

            menu.removeAttribute(
              "open"
            );

          } else {

            menu.setAttribute(
              "open",
              ""
            );

          }

        }
      );

    }


    handleLocalization(
      event
    ) {

      const select =
        event.currentTarget;


      const form =
        select.closest(
          "form"
        );


      if (
        !form
      ) {

        return;

      }


      if (
        typeof form.requestSubmit ===
        "function"
      ) {

        form.requestSubmit();

      } else {

        form.submit();

      }

    }


    destroy() {

      if (
        typeof MOBILE_QUERY.removeEventListener ===
        "function"
      ) {

        MOBILE_QUERY.removeEventListener(
          "change",
          this.handleViewport
        );

      } else {

        MOBILE_QUERY.removeListener(
          this.handleViewport
        );

      }


      this.localizationSelects.forEach(
        (select) => {

          select.removeEventListener(
            "change",
            this.handleLocalization
          );

        }
      );

    }

  }


  function initializeFooter(
    footer
  ) {

    if (
      !footer ||
      instances.has(
        footer
      )
    ) {

      return;

    }


    const instance =
      new BarrosFooter(
        footer
      );


    instances.set(
      footer,
      instance
    );

  }


  function destroyFooter(
    footer
  ) {

    const instance =
      instances.get(
        footer
      );


    if (
      !instance
    ) {

      return;

    }


    instance.destroy();


    instances.delete(
      footer
    );

  }


  function initializeAll(
    container = document
  ) {

    if (
      container.matches?.(
        FOOTER_SELECTOR
      )
    ) {

      initializeFooter(
        container
      );

    }


    container
      .querySelectorAll?.(
        FOOTER_SELECTOR
      )
      .forEach(
        initializeFooter
      );

  }


  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      () => {

        initializeAll();

      }
    );

  } else {

    initializeAll();

  }


  document.addEventListener(
    "shopify:section:load",
    (event) => {

      initializeAll(
        event.target
      );

    }
  );


  document.addEventListener(
    "shopify:section:unload",
    (event) => {

      const footer =
        event.target.matches?.(
          FOOTER_SELECTOR
        )
          ? event.target
          : event.target
              .querySelector?.(
                FOOTER_SELECTOR
              );


      if (
        footer
      ) {

        destroyFooter(
          footer
        );

      }

    }
  );

})();